import { loadSponsors } from '@/services/sponsors'
import { selectSponsors } from '@/domain/sponsors'

export async function loadSidebarSponsors(options: { signal?: AbortSignal } = {}) {
  return selectSponsors(await loadSponsors(options), 'sidebar')
}
